import { render } from "./ConseilsBonnetsEtFranges.vue?vue&type=template&id=edfb1776&scoped=true"
import script from "./ConseilsBonnetsEtFranges.vue?vue&type=script&lang=js"
export * from "./ConseilsBonnetsEtFranges.vue?vue&type=script&lang=js"

import "./ConseilsBonnetsEtFranges.vue?vue&type=style&index=0&id=edfb1776&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edfb1776"]])

export default __exports__